import styled from 'styled-components';

export const TableContainer = styled.div`
  margin-top: 2rem;
`;
